import { Entity } from '../entity';

export enum TaxRateType {
    Income = 'Income',
    Expense = 'Expense'
}

export interface TaxRate extends Entity {
    type: TaxRateType;
    rate: number;
    isDefault: boolean;
    inUse?: boolean;
}

export interface TaxRateSummary extends Entity {
    rate: number;
}